import React, { useState, useCallback, useEffect } from 'react';
import Calendar from './CalendarRice';
import ArticleTableCalendar from './ArticleTableCalendar';
import axios from "axios"

function CalendarParentArticleRice() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [articles, setArticles] = useState([]);
    const [fetchKey, setFetchKey] = useState(0);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        // 좁은 화면 여부 상관없이 항상 YYYY-MM-DD 형식으로 출력
        return `${year}-${month}-${day}`;
    };

    const start = startDate ? formatDate(startDate) : '';
    const end = endDate ? formatDate(endDate) : '';

    // start와 end를 바탕으로 뉴스 데이터 가져오기
    const fetchArticles = useCallback(() => {
        const baseURL = 'https://disease.scnu.ac.kr/riceblast';
        const url = (start && end)
            ? `${baseURL}?start=${start}&end=${end}`
            : baseURL;

        axios.get(url)
            .then(response => {
                setArticles(response.data.reverse());   // 역순 정렬
            })
            .catch(error => {
                console.error('뉴스 데이터를 가져오는 데 실패했습니다: ', error);
            });
    }, [start, end]);

// 날짜나 fetchKey가 변경될 때마다 데이터 가져오기
    useEffect(() => {
        fetchArticles();
    }, [fetchArticles, fetchKey]);

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };

    const applyDates = () => {
        // 날짜가 변경된 뒤 적용 버튼을 눌러야 실제 데이터 fetch
        setFetchKey(prevKey => prevKey + 1);
    };

    const today = new Date();
    const currentYear = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

    return (
        <div style={{ position: "relative", zIndex: "3", display: "flex", flexDirection: "column" }}>
            <div style={{ position: "relative", zIndex: "3", display: "grid", gridAutoRows: "auto" }}>
                <div style={{ display: "grid", gridTemplateRows: "auto auto", rowGap: "20px", marginBottom: "20px" }}>
                    <div style={{ display: "grid", gridAutoFlow: "column", alignItems: "center", gap: "10px" }}>
                        시작 날짜
                        <Calendar onDateSelect={handleStartDateChange}  />
                    </div>
                    <div style={{ display: "grid", gridAutoFlow: "column", alignItems: "center", gap: "10px"}}>
                        종료 날짜
                        <Calendar onDateSelect={handleEndDateChange} />
                    </div>
                </div>
            </div>


            <h1>시작 날짜: {startDate ? formatDate(startDate) :  "1990-02-26"}</h1>
            <h1>종료 날짜: {endDate ? formatDate(endDate) : currentYear}</h1>

            <ArticleTableCalendar articles={articles} />
        </div>
    );
}

export default CalendarParentArticleRice;
